module.exports = __webpack_public_path__ + "static/media/CTS_V2.a9789f1c.png";